var map = {
	"../approval/approval.module": [
		"./src/app/pages/approval/approval.module.ts",
		"common",
		"approval-approval-module"
	],
	"../historic/historic.module": [
		"./src/app/pages/historic/historic.module.ts",
		"historic-historic-module"
	],
	"../register-list/register-list.module": [
		"./src/app/pages/register-list/register-list.module.ts",
		"common",
		"register-list-register-list-module"
	],
	"../tracing/tracing.module": [
		"./src/app/pages/tracing/tracing.module.ts",
		"tracing-tracing-module"
	],
	"../treatment/treatment.module": [
		"./src/app/pages/treatment/treatment.module.ts",
		"common",
		"treatment-treatment-module"
	],
	"../validation/validation.module": [
		"./src/app/pages/validation/validation.module.ts",
		"validation-validation-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"common",
		"pages-home-home-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;